import React from 'react';
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

const MultipleHideCategories = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'categories.multi.hide',
        text: 'Do you want to hide selected categories?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple hide categories" >
      <FontAwesomeIcon
        rotation={180}
        color={'gray'}
        size={'lg'}
        icon={solid('eye-slash')}/>
    </button>
  );
};

export default MultipleHideCategories;
